var _path, _rect, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTileWhitePreview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 74,
    viewBox: "0 0 81 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80.43 37L60.4537 73.5H20.5463L0.569985 37L20.5463 0.5L60.4537 0.500002L80.43 37Z",
    fill: "white",
    stroke: "#29A4CC"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 13,
    width: 48,
    height: 48,
    rx: 24,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.708 26.667C46.7078 27.7393 46.2838 28.768 45.5283 29.5289C43.7891 31.2824 42.1015 33.1108 40.2964 34.8001C40.0948 34.9837 39.8305 35.0829 39.5579 35.0773C39.2854 35.0716 39.0254 34.9616 38.8316 34.7698L33.6317 29.5307C32.8758 28.7693 32.4517 27.7399 32.4517 26.667C32.4517 25.5942 32.8758 24.5648 33.6317 23.8034C34.0089 23.4234 34.4575 23.1219 34.9517 22.9161C35.446 22.7103 35.976 22.6043 36.5114 22.6043C37.0468 22.6043 37.5769 22.7103 38.0711 22.9161C38.5653 23.1219 39.014 23.4234 39.3911 23.8034L39.58 23.994L39.7689 23.8034C40.335 23.2311 41.0587 22.8403 41.8477 22.6806C42.6366 22.5209 43.4553 22.5996 44.1994 22.9067C44.9435 23.2138 45.5794 23.7353 46.0262 24.405C46.4729 25.0746 46.7102 25.8621 46.708 26.667Z",
    stroke: "#1C5365",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2722 51.1159L57.0866 44.3016C57.2872 44.1012 57.4 43.8295 57.4002 43.546V34.1869C57.4002 33.478 57.1186 32.7981 56.6173 32.2968C56.116 31.7955 55.4361 31.5139 54.7272 31.5139C54.0183 31.5139 53.3384 31.7955 52.8371 32.2968C52.3358 32.7981 52.0542 33.478 52.0542 34.1869V42.2059",
    stroke: "#1C5365",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2721 43.9879L51.8011 42.459C51.8814 42.3787 51.9451 42.2835 51.9885 42.1786C52.032 42.0737 52.0543 41.9613 52.0541 41.8477C52.0539 41.6875 52.0091 41.5305 51.9248 41.3942C51.8404 41.258 51.7199 41.1478 51.5766 41.0761L50.7871 40.6823C50.1183 40.3479 49.3613 40.2323 48.6232 40.3519C47.885 40.4715 47.2032 40.8203 46.6743 41.3488L45.0794 42.9437C44.411 43.6119 44.0353 44.5183 44.0351 45.4634V51.1159M28.8881 51.1159L22.0738 44.3016C21.8732 44.1012 21.7604 43.8295 21.7601 43.546V34.1869C21.7601 33.478 22.0418 32.7981 22.543 32.2968C23.0443 31.7955 23.7242 31.5139 24.4331 31.5139C25.1421 31.5139 25.8219 31.7955 26.3232 32.2968C26.8245 32.7981 27.1061 33.478 27.1061 34.1869V42.2059",
    stroke: "#1C5365",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.888 43.9882L27.3591 42.4592C27.2788 42.3789 27.2152 42.2836 27.1717 42.1787C27.1283 42.0739 27.106 41.9615 27.106 41.848C27.106 41.5219 27.2913 41.2243 27.5836 41.0764L28.373 40.6825C29.0418 40.3481 29.7989 40.2326 30.537 40.3522C31.2751 40.4718 31.9569 40.8205 32.4859 41.349L34.0808 42.9439C34.7492 43.6121 35.1248 44.5185 35.125 45.4636V51.1162",
    stroke: "#1C5365",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTileWhitePreview);
export default __webpack_public_path__ + "static/media/tileWhitePreview.9ea15204b40b6a38063c2f0e669d3616.svg";
export { ForwardRef as ReactComponent };